import {useState, useCallback, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {TState} from '../redux/store.type';
import {getEventSettings} from '../redux/event/eventActions';
import {getLeadWhatsappTemplate} from '../redux/publish/publishActions';
import {UseSendDataConfig, SendData} from './sendHooks.types';
import {useDefaultFbImage} from './useDefaultFbImage';

export const useSendData = ({defaultMessage, defaultSubject, defaultEmailBody, defaultSmsMessage}: UseSendDataConfig) => {
    const getEventSettingsXHR = useSelector((s: TState) => s.event.getEventSettingsXHR);
    const whatsappTemplate = useSelector((s: TState) => s.publish.leadWhatsappTemplate);
    const defaultWhatsappImage = useDefaultFbImage(true);
    const defaultEmailImage = useDefaultFbImage(false);

    const [whatsappData, setWhatsappData] = useState({
        image: defaultWhatsappImage,
        message: defaultMessage
    });

    const [emailData, setEmailData] = useState({
        image: defaultEmailImage,
        emailBody: defaultEmailBody,
        emailSubject: defaultSubject
    });

    const [smsData, setSmsData] = useState({message: defaultSmsMessage});

    const handleDataSave = useCallback((data: any, key: string, type: keyof SendData) => {
        const setters = {
            whatsapp: setWhatsappData,
            email: setEmailData,
            sms: setSmsData
        };
        
        const setter = setters[type];
        if(setter) {
            setter(prev => ({...prev, [key]: data}));
        }
    }, []);

    // Initialize event settings
    useEffect(() => {
        if(!getEventSettingsXHR) {
            getEventSettings().then(); 
        }
        if(!whatsappTemplate) {
            getLeadWhatsappTemplate().then();
        }
    }, []);

    // Update image when design data becomes available
    useEffect(() => {
        if(defaultWhatsappImage.path !== whatsappData.image.path) 
            setWhatsappData(prev => ({...prev, image: defaultWhatsappImage}));
        if(defaultEmailImage.path !== emailData.image.path)
            setEmailData(prev => ({...prev, image: defaultEmailImage}));
    }, [defaultWhatsappImage.path, defaultEmailImage.path]);

    return {whatsappData, emailData, smsData, handleDataSave, whatsappTemplate};
};
